import { Injectable, inject, signal } from '@angular/core';
import { MembersService } from './members.service';

/**
 * The builder's **Works offline** switch (CONTEXT.md), as the app's Settings shows it. Holds state only; the value
 * lives on the project's client document and reaches a Live app when it is next published.
 */
@Injectable({ providedIn: 'root' })
export class WorksOfflineSettingService {
  private members = inject(MembersService);

  /** Only a stored `true` is on, so every project that never set it is off. */
  readonly on = signal(false);

  async load(): Promise<void> {
    try {
      this.on.set((await this.members.getWorksOffline()) === true);
    } catch (e) {
      console.error('WorksOfflineSetting.load failed; showing off', e);
      this.on.set(false);
    }
  }

  /**
   * Optimistic, like the app bar colours: the switch moves now, the write follows. A failed write puts it back and
   * still rejects, so the card can say the change was not saved.
   */
  async set(on: boolean): Promise<void> {
    const previous = this.on();
    this.on.set(on);
    try {
      await this.members.setWorksOffline(on);
    } catch (e) {
      if (this.on() === on) this.on.set(previous);
      throw e;
    }
  }
}
